// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3yxmz","noteContainer":"styles_noteContainer__38Mnw","seeMoreButton":"styles_seeMoreButton__2-SCO"};